import { Service } from '../../services/buildings';
import { Unit } from '../../services/units';
import { ActionInterface } from '../../utils/redux';
import { UnitActions } from './actions';
import UnitState, { UnitStateInterface } from './state';

const INITIAL_STATE = new UnitState();

export default function UnitReducer(
  state = INITIAL_STATE,
  action: ActionInterface<UnitActions>
): UnitStateInterface {
  switch (action.type) {
    case UnitActions.getUnitStart:
      return getUnitStart(state);
    case UnitActions.getUnitSuccess:
      return getUnitSuccess(state, action);
    case UnitActions.getUnitError:
      return getUnitError(state, action);
    case UnitActions.getServicesStart:
      return getServicesStart(state);
    case UnitActions.getServicesSuccess:
      return getServicesSuccess(state, action);
    case UnitActions.getServicesError:
      return getServicesError(state, action);
    default:
      return state;
  }
}

// reducers
function getUnitStart(state: UnitStateInterface): UnitStateInterface {
  return { ...state, error: undefined };
}
function getUnitSuccess(
  state: UnitStateInterface,
  action: ActionInterface<UnitActions, Unit>
): UnitStateInterface {
  return { ...state, error: null, unit: action.payload || null };
}
function getUnitError(
  state: UnitStateInterface,
  action: ActionInterface<UnitActions>
): UnitStateInterface {
  return { ...state, error: action.payload, unit: null };
}

function getServicesStart(state: UnitStateInterface): UnitStateInterface {
  return {
    ...state,
    error: undefined,
    services: [],
  };
}
function getServicesSuccess(
  state: UnitStateInterface,
  action: ActionInterface<UnitActions, Service[]>
): UnitStateInterface {
  return {
    ...state,
    error: null,
    services: action.payload || [],
  };
}
function getServicesError(
  state: UnitStateInterface,
  action: ActionInterface<UnitActions>
): UnitStateInterface {
  return {
    ...state,
    error: action.payload,
    services: [],
  };
}
